module.exports = __webpack_public_path__ + "img/3fish_rect.20bf3ed9.png";